// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viso-modal-delete__input{margin-top:20px}", "",{"version":3,"sources":["webpack://./app/components/ModalCheckbox/style.scss"],"names":[],"mappings":"AAEE,0BACE,eAAA","sourcesContent":[".viso-modal-delete {\n  \n  &__input {\n    margin-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
